import { Component, Prop, Vue } from 'vue-property-decorator';
import { DataType, FieldDesc, WidgetAppearance } from '../../../classes/wxFieldDesc';
import { Validation } from '../../../lib/validation';

@Component({})
export class WxBaseWidget extends Vue {
    @Prop(String) public fieldName!: string;
    @Prop(Object) public item!: any;
    // @Prop(String) private label!: string;
    @Prop(String) private readonly hint!: string;

    private xFieldDesc!: FieldDesc;

    public get fieldDesc() {
        return this.xFieldDesc;
    }

    public set fieldDesc(fieldDesc: FieldDesc) {
        if (this.xFieldDesc === undefined && !!fieldDesc) {
            this.xFieldDesc = fieldDesc;
        }
    }

    public created() {
        this.$emit('widget-created', this);
    }

    protected get computedLabel(): string {
        const label = this.xFieldDesc === undefined ? this.fieldName : String(this.$t(this.xFieldDesc.caption));
        return this.required ? label + '*' : label;
    }

    protected get computedHint(): string {
        return this.xFieldDesc === undefined ? '' : String(this.$t(this.xFieldDesc.hint));
    }

    protected get readonly() {
        return this.xFieldDesc.insertStyle === WidgetAppearance.Readonly || this.xFieldDesc.updateStyle === WidgetAppearance.Readonly;
    }

    protected get required() {
        return this.xFieldDesc.insertStyle === WidgetAppearance.Required || this.xFieldDesc.updateStyle === WidgetAppearance.Required;
    }

    protected get rules() {
        const rules = [];

        if (this.xFieldDesc.insertStyle === WidgetAppearance.Required || this.xFieldDesc.updateStyle === WidgetAppearance.Required) {
            rules.push((v: any) => (!!v && !(typeof v === 'string' && v.trim().length === 0)) || this.$t('$validation.REQUIRED'));
        }
        if (this.xFieldDesc.size && this.xFieldDesc.size > 0) {
            rules.push(
                (v: string) =>
                    !v || v.length === 0 || v.length <= this.xFieldDesc.size || this.$t('$validation.MAX_CHARS_ALLOWED', [this.xFieldDesc.size])
            );
        }
        if (this.xFieldDesc.options && this.xFieldDesc.options.rule) {
            rules.push((v: any) => !v || new RegExp(this.xFieldDesc.options.rule.regex).test(v) || this.$t(this.xFieldDesc.options.rule.text));
        }
        if (this.xFieldDesc.dataType && this.xFieldDesc.dataType === DataType.IMEI) {
            rules.push((v: string) => !v || v.length === 0 || Validation.isIMEIValid(v) || this.$t('$validation.VALID_IMEI'));
        }

        return rules;
    }
}
